import { ButtonLink } from '@/components/ui/Button'
import { PageSeo } from '@/components/seo/PageSeo'
import { sitePages } from '@/config/pages'

export const NotFoundPage = () => (
  <>
    <PageSeo page={sitePages.notFound} />
    <div className="nav-space" aria-hidden="true" />
    <section className="x-wrap not-found" aria-labelledby="not-found-title">
      <p className="x-eyebrow x-eyebrow--ink">404</p>
      <h1 id="not-found-title" className="display">
        Page not found
      </h1>
      <p className="hero-lead">The page is missing or the article slug has changed.</p>
      <ButtonLink to={sitePages.home.path} variant="ink">
        Back home
      </ButtonLink>
    </section>
  </>
)
